import { render, staticRenderFns } from "./NationalRepresentatives.vue?vue&type=template&id=245c6605&scoped=true&"
import script from "./NationalRepresentatives.vue?vue&type=script&lang=ts&"
export * from "./NationalRepresentatives.vue?vue&type=script&lang=ts&"
import style0 from "./NationalRepresentatives.vue?vue&type=style&index=0&id=245c6605&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245c6605",
  null
  
)

export default component.exports